<script lang="ts">
  import { page } from "$app/stores";
  import ErrorPage from "$lib/layouts/ErrorPage/ErrorPage.svelte";
  import { Errors } from "$lib/data/errors.data";
  export let error: Error;

  const dev = process.env.NODE_ENV === "development";

  export function isUnknownError(message: string): boolean {
    if (message === Errors.NotFound || message === Errors.ServerError) {
      return false;
    }
    return true;
  }

  $: if ($page && $page.error && $page.error.message) {
    console.error($page.error.message);
    console.error($page.status);
  }

  $: if (error && isUnknownError(error.message)) {
    console.error(error.message);
  }

  $: if (error && error.stack) {
    console.error(error.stack);
  }
</script>

<svelte:head>
  <title>{$page.status}</title>
</svelte:head>

<ErrorPage code={$page.status} slot={true} />
